'use client'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

import fabEvent from '@/utils/gaEvents/fabEvent'

import useHash from '@/shared/hooks/useHash'
import type { Dispatch, SetStateAction } from 'react'

import { SALE_TYPE } from '@/enums/detail'
import { HASH_KEY_TYPE } from '@/enums/map'

interface useFilterSearchBarViewModelProps {
  isFilterOn: boolean
  setIsFilterOn: Dispatch<SetStateAction<boolean>>
}

export interface FilterSearchBarViewModel {
  texts: {
    placeholder: string
  }
  states: {
    activeIndex: number
    isShowTip: boolean
    buttons: { id: number; text: string }[]
  }
  setters: {
    setIsShowTip: Dispatch<SetStateAction<boolean>>
    setActiveIndex: Dispatch<SetStateAction<number>>
  }
  handlers: {
    onFilterButtonClick: (id: number) => void
  }
}

const useFilterSearchBarViewModel = ({
  isFilterOn,
  setIsFilterOn
}: useFilterSearchBarViewModelProps): FilterSearchBarViewModel => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isShowTip, setIsShowTip] = useState(false)
  const router = useRouter()
  const { updateHash } = useHash()

  useEffect(() => {
    setActiveIndex(isFilterOn ? 1 : 0)
  }, [isFilterOn])

  const buttons = [
    { id: 0, text: '전체' },
    { id: 1, text: '구매 가능' }
  ]

  const onFilterButtonClick = (id: number) => {
    const isFilterOn = id === 1
    setIsFilterOn(isFilterOn)
    let hash = ''
    const pathname = window.location.pathname
    const searchParams = window.location.search

    if (isFilterOn) {
      fabEvent.onClickFilterButton()
      hash = updateHash({ [HASH_KEY_TYPE.IS_SALE]: SALE_TYPE.ON })
    } else {
      hash = updateHash({ [HASH_KEY_TYPE.IS_SALE]: SALE_TYPE.OFF })
    }
    router.push(`${pathname}${searchParams}${hash}`)
  }

  return {
    texts: {
      placeholder: '목적지 또는 주소 검색'
    },
    states: {
      activeIndex,
      isShowTip,
      buttons
    },
    setters: { setIsShowTip, setActiveIndex },
    handlers: { onFilterButtonClick }
  }
}

export default useFilterSearchBarViewModel
